// extracted by mini-css-extract-plugin
export default {"root":"Faq_root__Ad4kG","head":"Faq_head__UWi4C","wave":"Faq_wave__P8TDR","list":"Faq_list__wUOlF","item":"Faq_item__PrrWj","answer":"Faq_answer__Q1qLI","open":"Faq_open__ehLJe"};